// src/components/PermissionsForm.js
import React from 'react';
import { Form } from 'react-bootstrap';

function PermissionsForm({ availablePermissions, selectedPermissions, setSelectedPermissions }) {
  const handleCheckboxChange = (e) => {
    const permission = e.target.value;
    if (e.target.checked) {
      setSelectedPermissions([...selectedPermissions, permission]);
    } else {
      setSelectedPermissions(selectedPermissions.filter(p => p !== permission));
    }
  };

  return (
    <Form.Group className="mb-2">
      <Form.Label>Permissions</Form.Label>
      {availablePermissions.map((perm) => (
        <Form.Check 
          key={perm.id}
          id={`formPermission-${perm.id}`} // unique id for each checkbox
          type="checkbox"
          label={perm.name}
          value={perm.name}
          checked={selectedPermissions.includes(perm.name)}
          onChange={handleCheckboxChange}
        />
      ))}
    </Form.Group>
  );
}

export default PermissionsForm;